$('#iyarnSendForm').on('click', function (event) {
    let closestForm = $(event.target).closest('form');

    let userName = closestForm.find('[name=userName]').val(),
        userEmail = closestForm.find('[name=userEmail]').val(),
        organisation = closestForm.find('[name=organisation]').val(),
        userMessage = closestForm.find('[name=userMessage]').val(),
        userPhone = closestForm.find('[name=userPhone]').val();

    if (!$('.invalid-feedback').is(':visible')) {
        $.ajax({
            url: $('#ajax_url').val(),
            type: "POST",
            cache: false,
            data: {
                action: 'send_email',
                name: userName,
                email: userEmail,
                organisation: organisation,
                message: userMessage,
                userPhone: userPhone,
            },
            success: function (res) {
                successSend(res);
            }
        });
    }
});
